module.exports = __webpack_public_path__ + "media/images/icons/filled/setting-71aa80cb9772288ff31d63ec6d8ddc77.svg";